<!-- 订单中心 -->
<template>
    <div class="container">
        <!-- 搜索栏 -->
        <div class="search-bar">
            <Input 
                v-model="searchParams.keyword" 
                placeholder="请输入人员名称" 
                clearable
                style="width: 200px; margin-right: 12px;"
            />
            <Select 
                v-model="searchParams.status" 
                placeholder="通过发货状态" 
                clearable
                style="width: 150px; margin-right: 12px;"
            >
                <Option value="">全部</Option>
                <Option value="待发货">待发货</Option>
                <Option value="已发货">已发货</Option>
                <Option value="已完成">已完成</Option>
            </Select>
            <Select 
                v-model="searchParams.delivery_type" 
                placeholder="发货方式" 
                clearable
                style="width: 150px; margin-right: 12px;"
            >
                <Option value="">全部</Option>
                <Option value="快递">快递</Option>
                <Option value="自提">自提</Option>
            </Select>
            <Select 
                v-model="searchParams.activity_type" 
                placeholder="活动类型" 
                clearable
                style="width: 150px; margin-right: 12px;"
            >
                <Option value="">全部</Option>
                <Option value="大转盘">大转盘</Option>
                <Option value="积分商城">积分商城</Option>
            </Select>
            <DatePicker 
                type="daterange" 
                v-model="searchParams.dateRange"
                placeholder="选择时间段"
                style="width: 250px; margin-right: 12px;"
            />
            <Button type="warning" icon="ios-search" @click="handleSearch">确认搜索</Button>
        </div>

        <!-- 批量操作栏 -->
        <div class="batch-bar">
            <Checkbox v-model="selectAll" @on-change="handleSelectAll">全选</Checkbox>
            <span class="selected-count">已选{{ selectedRows.length }}个</span>
            <Button size="small" type="primary" :disabled="selectedRows.length === 0" @click="handleBatchShip">批量打印</Button>
            <Button size="small" type="warning" :disabled="selectedRows.length === 0" @click="handleBatchExport">批量导出</Button>
        </div>

        <!-- 订单列表 -->
        <Table 
            :columns="columnsTable" 
            :data="dataTable" 
            border
            @on-selection-change="handleSelectionChange"
        >
            <template slot-scope="{ row }" slot="product">
                <div class="product-info">
                    <img :src="row.product_image || require('@/assets/blank.png')" alt="" class="product-img" />
                    <div class="product-detail">
                        <div>{{ row.product_name }}</div>
                        <div class="product-qty">共计 {{ row.quantity }} 个商品</div>
                    </div>
                </div>
            </template>
            <template slot-scope="{ row }" slot="member">
                <div>{{ row.member_name }}</div>
                <div class="member-phone">{{ row.member_phone }}</div>
            </template>
            <template slot-scope="{ row }" slot="activity">
                <Tag :color="getActivityColor(row.activity_type)">{{ row.activity_type }}</Tag>
            </template>
            <template slot-scope="{ row }" slot="status">
                <Tag :color="getStatusColor(row.status)">{{ row.status }}</Tag>
            </template>
            <template slot-scope="{ row }" slot="operate">
                <Button size="small" type="primary" ghost @click="goViewDetail(row)">详情</Button>
                <Button size="small" type="error" ghost @click="goDelete(row)" style="margin-left: 8px;">删除</Button>
            </template>
        </Table>

        <!-- 分页 -->
        <div class="text-align-right mt24">
            <Page
                :current="pageParams.page"
                :page-size="pageParams.limit"
                :total="total"
                show-total
                show-elevator
                show-sizer
                @on-change="handleChangePage"
                @on-page-size-change="handleChangePageSize"
            />
        </div>

        <!-- 订单详情弹框 -->
        <Modal
            v-model="detailModal"
            title="记录详情"
            width="700"
            :mask-closable="false"
        >
            <div class="detail-container" v-if="detailData">
                <!-- 订单头部信息 -->
                <div class="detail-header">
                    <div class="header-left">
                        <div class="order-number">订单编号：{{ detailData.order_number }}</div>
                        <div class="member-info">
                            <span>会员名称：{{ detailData.member_name }}</span>
                        </div>
                        <div class="activity-info">
                            <span>活动类型：{{ detailData.activity_type }}</span>
                        </div>
                        <div class="activity-name">
                            <span>活动名称：{{ detailData.activity_name }}</span>
                        </div>
                        <div class="product-name">
                            <span>商品名称：{{ detailData.product_name }}</span>
                        </div>
                    </div>
                    <div class="header-right">
                        <Tag :color="getStatusColor(detailData.status)" size="large">{{ detailData.status }}</Tag>
                    </div>
                </div>

                <!-- 收货人信息 -->
                <div class="detail-section">
                    <div class="section-title">收货人信息</div>
                    <div class="section-content">
                        <div><strong>收货人：</strong>{{ detailData.receiver_name }}</div>
                        <div><strong>联系方式：</strong>{{ detailData.receiver_phone }}</div>
                        <div><strong>收货地址：</strong>{{ detailData.receiver_address }}</div>
                    </div>
                </div>

                <!-- 配送信息（仅已发货和已完成显示） -->
                <div class="detail-section" v-if="detailData.status !== '待发货'">
                    <div class="section-title">配送信息</div>
                    <div class="section-content">
                        <div><strong>操作人员：</strong>{{ detailData.operator_name }}</div>
                        <div><strong>发货时间：</strong>{{ detailData.ship_time }}</div>
                        <div><strong>配送信息：</strong>{{ detailData.delivery_info }}</div>
                        <div><strong>备注说明：</strong>{{ detailData.remark }}</div>
                    </div>
                </div>

                <!-- 核销员信息（待核销、待审核、已完成显示） -->
                <div class="detail-section" v-if="['待核销', '待审核', '已完成'].includes(detailData.status)">
                    <div class="section-title">核销员信息</div>
                    <div class="section-content">
                        <div><strong>核销员：</strong>{{ detailData.writeoff_name }}</div>
                        <div><strong>核销时间：</strong>{{ detailData.writeoff_time }}</div>
                    </div>
                </div>

                <!-- 备注 -->
                <div class="detail-section">
                    <div class="section-title">备注</div>
                    <div class="section-content remark-content">{{ detailData.remark_text || '无' }}</div>
                </div>
            </div>

            <div slot="footer">
                <Button @click="detailModal = false">取消</Button>
                <Button type="warning" @click="handleConfirm">确认</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    order_list,
    order_delete,
    order_detail,
} from "@/api/index";

export default {
    name: 'OrderCenter',
    data() {
        return {
            // 搜索参数
            searchParams: {
                keyword: '',
                status: '',
                delivery_type: '',
                activity_type: '',
                dateRange: null,
            },
            // 分页参数
            pageParams: {
                page: 1,
                limit: 20,
            },
            total: 0,
            // 表格列配置
            columnsTable: [
                { type: 'selection', width: 60, align: 'center' },
                { 
                    title: '订单编号', 
                    key: 'order_number', 
                    align: 'center',
                    minWidth: 180,
                },
                { 
                    title: '商品信息', 
                    slot: 'product', 
                    align: 'left',
                    minWidth: 250,
                },
                { 
                    title: '会员名称', 
                    slot: 'member', 
                    align: 'center',
                    minWidth: 150,
                },
                { 
                    title: '活动类型', 
                    slot: 'activity', 
                    align: 'center',
                    width: 120,
                },
                { 
                    title: '状态', 
                    slot: 'status', 
                    align: 'center',
                    width: 100,
                },
                { 
                    title: '下单时间', 
                    key: 'create_time', 
                    align: 'center',
                    width: 160,
                },
                {
                    title: '操作',
                    slot: 'operate',
                    align: 'center',
                    width: 150,
                    fixed: 'right',
                },
            ],
            // 表格数据
            dataTable: [],
            // 选中行
            selectedRows: [],
            selectAll: false,
            // 详情弹框
            detailModal: false,
            detailData: null,
        };
    },
    mounted() {
        this.getOrderList();
    },
    methods: {
        // 获取订单列表
        getOrderList() {
            const params = {
                ...this.pageParams,
                ...this.searchParams,
            };
            
            // 处理日期范围
            if (this.searchParams.dateRange && this.searchParams.dateRange.length === 2) {
                params.start_date = this.formatDate(this.searchParams.dateRange[0]);
                params.end_date = this.formatDate(this.searchParams.dateRange[1]);
            }
            
            order_list(params)
                .then((res) => {
                    this.dataTable = res.data?.data || [];
                    this.total = res.data?.total || 0;
                })
                .catch((err) => {
                    this.$Message.error(err.msg || '获取订单列表失败');
                    this.dataTable = [];
                    this.total = 0;
                });
        },
        
        // 搜索
        handleSearch() {
            this.pageParams.page = 1;
            this.getOrderList();
        },
        
        // 分页切换
        handleChangePage(page) {
            this.pageParams.page = page;
            this.getOrderList();
        },
        
        // 每页条数改变
        handleChangePageSize(size) {
            this.pageParams.limit = size;
            this.pageParams.page = 1;
            this.getOrderList();
        },
        
        // 全选
        handleSelectAll(status) {
            if (status) {
                this.selectedRows = [...this.dataTable];
            } else {
                this.selectedRows = [];
            }
        },
        
        // 选择变化
        handleSelectionChange(selection) {
            this.selectedRows = selection;
            this.selectAll = selection.length === this.dataTable.length && selection.length > 0;
        },
        
        // 批量打印
        handleBatchShip() {
            if (this.selectedRows.length === 0) {
                this.$Message.warning('请选择要打印的订单');
                return;
            }
            this.$Message.success(`已选择 ${this.selectedRows.length} 个订单进行批量打印`);
            // TODO: 调用批量打印接口
        },
        
        // 批量导出
        handleBatchExport() {
            if (this.selectedRows.length === 0) {
                this.$Message.warning('请选择要导出的订单');
                return;
            }
            this.$Message.success(`已选择 ${this.selectedRows.length} 个订单进行批量导出`);
            // TODO: 调用批量导出接口
        },
        
        // 查看详情
        goViewDetail(row) {
            order_detail({ id: row.id })
                .then((res) => {
                    this.detailData = res.data;
                    this.detailModal = true;
                })
                .catch((err) => {
                    this.$Message.error(err.msg || '获取订单详情失败');
                });
        },
        
        // 删除订单
        goDelete(row) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除该订单吗？',
                onOk: () => {
                    order_delete({ id: row.id })
                        .then((res) => {
                            this.getOrderList();
                            this.$Message.success(res.msg || '删除成功');
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg || '删除失败');
                        });
                },
                onCancel: () => {},
            });
        },
        
        // 确认按钮
        handleConfirm() {
            this.detailModal = false;
        },
        
        // 获取状态颜色
        getStatusColor(status) {
            const colorMap = {
                '待发货': 'orange',
                '已发货': 'blue',
                '已完成': 'green',
                '待核销': 'purple',
                '待审核': 'yellow',
            };
            return colorMap[status] || 'default';
        },
        
        // 获取活动类型颜色
        getActivityColor(type) {
            const colorMap = {
                '大转盘': 'cyan',
                '积分商城': 'magenta',
            };
            return colorMap[type] || 'default';
        },
        
        // 格式化日期
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
    },
};
</script>

<style scoped>
.container {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
}

/* 搜索栏 */
.search-bar {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding: 16px;
    background: #f5f7fa;
    border-radius: 4px;
}

/* 批量操作栏 */
.batch-bar {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding: 12px;
    background: #fafafa;
    border-radius: 4px;
}

.selected-count {
    margin: 0 16px;
    color: #666;
    font-size: 14px;
}

/* 商品信息 */
.product-info {
    display: flex;
    align-items: center;
}

.product-img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
    margin-right: 12px;
}

.product-detail {
    flex: 1;
}

.product-qty {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
}

/* 会员信息 */
.member-phone {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
}

/* 详情弹框样式 */
.detail-container {
    padding: 0 10px;
}

.detail-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 16px;
    border-bottom: 1px solid #e8eaec;
    margin-bottom: 16px;
}

.header-left {
    flex: 1;
}

.order-number {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
}

.member-info,
.activity-info,
.activity-name,
.product-name {
    font-size: 14px;
    color: #666;
    margin-bottom: 4px;
}

.detail-section {
    margin-bottom: 16px;
}

.section-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
    padding-left: 8px;
    border-left: 3px solid #ff6600;
}

.section-content {
    font-size: 14px;
    color: #666;
    line-height: 1.8;
    padding-left: 11px;
}

.remark-content {
    min-height: 60px;
    padding: 8px;
    background: #f5f7fa;
    border-radius: 4px;
}

.text-align-right {
    text-align: right;
}

.mt24 {
    margin-top: 24px;
}

/* 表头样式 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}

::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}

::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}

::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>
